import "./switchUi.scss";
import clsx from "clsx";

const SwitchUI = ({ className, children, checked = false, onChange = () => {}, ...props }) => {
  return (
    <label className={clsx("switchUI", className)}>
      <input
        type="checkbox"
        className={"switchUI__input"}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <span className={"switchUI__toggle"} />
      {children && <span className={"switchUI__label"}>{children}</span>}
    </label>
  );
};

export default SwitchUI;
